import ApiService from '../api.services';

const CouriesService = {
    list: async function () {
        try {
            const response = await ApiService.get('/api/couriers');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    get: async function (id) {
        try {
            const response = await ApiService.get(`/api/couriers/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    add: async function (data, documents, truck) {
        try {
            data.truck = truck;
            data.documents = documents;
            const res = await ApiService.post('/api/couriers', data);
            return res.data;
        } catch (error) {
            throw error;
        }
    },
    update: async function (id, form) {
        const data = {
            courier: form
        }
        try {
            const response = await ApiService.put(`/api/couriers/${id}`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    delete: async function (id) {
        try {
            const response = await ApiService.delete(`/api/couriers/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default CouriesService;

export { CouriesService };

